import { render, staticRenderFns } from "./emptyData.vue?vue&type=template&id=46ce0607"
import script from "./emptyData.vue?vue&type=script&lang=js"
export * from "./emptyData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports